import React, { useState, useEffect } from 'react';
import { Grid, Box } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";

import { getEvaluateLogData, updateLog } from "./Services";
import { getAsset, unicodeToString, durationCalculate, userLogs, joinByKeys } from "../../Js/Common";
import { calculateOptionWiseScore } from "../../Js/ScoreCalculate";
import InstructionCard from "../../Components/Card/AssetUI/InstructionCard";
import MediaCard from "../../Components/Card/AssetUI/MediaCard";
import TopButton from "../../Components/UI/TopButtons";
import RewardsCard from "../../Components/Card/RewardsCard";


import { assessSliceActions } from "../../Store/Slices/AssessSlice";

import BookEvaluate from "./Types/BookEvaluate";
import NBEvaluate from './Types/NBEvaluate';
import { findIndex, map } from "lodash";

const manualEvalAssetTypes = ["DIC", "BOOK", "REC", "NB"];
const ILTTypeAssets = ["MEDIA", "ILT", "OP", "CI", "AVP", "RA"];
const FullWidthAssets = ["WORD", "WS"];

const AssessAssetTypes = (props) => {
    //Hooks
    const styles = useStyles();
    const navigation = useNavigate();
    const dispatch = useDispatch();

    // Redux state
    const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
    const { paramsdata } = useSelector((state) => state.common);
    const { duration, durationStartTimeStamp } = useSelector(
        (state) => state.assess
    );

    // State    
    const [logData, setLogData] = useState([]);
    const [assetType, setAssetType] = useState(null);
    const [assetData, setAssetData] = useState(null);
    const [teacherEvaluation, setTeacherEvaluation] = useState([]);

    useEffect(() => {
        console.log("AssessAssetTypes paramsdata=====>", paramsdata);
        const getAssetData = async () => {
            let resLogData = await getEvaluateLogData(
                paramsdata.assetId,
                paramsdata.taskId,
                paramsdata.assignmentId,
                paramsdata.userId,
                userInfo.site_uuid
            );
            console.log("resLogData", resLogData);
            let tmpLogData = resLogData.data[0];
            setLogData(resLogData.data[0]);
            setAssetType(resLogData.data[0].outcome.assetType);
            // console.log("value=====>", resLogData.data[0].outcome.assetType.value);
            // if (resLogData.data[0].outcome.assetType.value !== 'BOOK') {
            let resAssetData = await getAsset(paramsdata.assetId);
            console.log("resAssetData", resAssetData);
            setAssetData(resAssetData.data[0]);

            let userBookPages = tmpLogData.outcome.userAnswer[0]['ans'];
            let teacherEval = [];
            for (let i = 0; i < userBookPages.length; i++) {
                let obj = { value: "Select Remark", id: null, score: 0 };
                teacherEval.push(obj);
            }
            setTeacherEvaluation(teacherEval);     
            
            dispatch(assessSliceActions.resetState());
            dispatch(assessSliceActions.setDurationFlag(true));
            dispatch(assessSliceActions.startDuration());
        };
        getAssetData();
    }, [paramsdata]);

    // Set teacher's evaluation
    const setTeacherEval = (selectedObj, index) => {
        let newArr = [...teacherEvaluation];
        newArr[index] = selectedObj;
        setTeacherEvaluation(newArr);
    };

    // To drop logs
    const logFunction = async (newValue, oldValue) => {
        newValue["outcome"]["duration"] = durationCalculate(
            duration,
            durationStartTimeStamp
        );
        return await userLogs({
            actor: userInfo.uid,
            verb: "evaluateAssignment",
            target: paramsdata.assignmentId,
            outcome: {
                newValue,
                oldValue: JSON.parse(oldValue),
            },
            context: logData["context"],
            site_uuid: userInfo.site_uuid,
        });
    };

    // Save evaluation score & drop log for teacher that teacher evaluate assignment
    const saveEvaluation = async (reaction, comment, trainerFeedbackAudio) => {
        let oldObject = JSON.stringify(logData);
        let logObject = logData;
        logObject["outcome"]["comments"] = comment;
        logObject["outcome"]["teacherRec"] = trainerFeedbackAudio;
        logObject["outcome"]["isEvaluated"] = "complete";
        logObject["outcome"]["teacherEval"] = map(teacherEvaluation, "id");
        logObject["outcome"]["genericScore"] = calculateOptionWiseScore({
            numberOfOptions: +teacherEvaluation.length,
            score: map(teacherEvaluation, "score"),
        });
        logObject["outcome"]["reaction"] = reaction;
        logObject["outcome"]["viewNotification"] = false;

        let response = await updateLog(
            logObject["outcome"],
            userInfo.site_uuid,
            logData["uid"]
        );

        if (response.status == 200) {
            dispatch(assessSliceActions.stopDuration());
            logFunction(logObject, oldObject);
            resetState();
            navigation(`/Assess/LearnerList`);
        }
    };

    const checkMediaAvailability = () => {
        if (
            assetData &&
            assetData.content &&
            assetData.content.content &&
            assetData.content.content.epage &&
            assetData.content.content.epage.instruction &&
            assetData.content.content.epage.instruction.media
        ) {
            let media = assetData.content.content.epage.instruction.media;
            if (
                (assetData.content.content.epage.options.question &&
                    assetData.content.content.epage.options.question.text) ||
                media.image ||
                media.audio ||
                (typeof media.article == "string" && media.article) ||
                (typeof media.article == "object" &&
                    media.article.length > 0 &&
                    media.article[0]["text"].trim() != "")
            ) {
                return true;
            } else {
                return false;
            }
        }
    };

    // Reset state
    const resetState = () => {
        setAssetData(null);
        setLogData(null);        
        setTeacherEvaluation([]);
    };

    return (
        <>
            <TopButton
                title={`Evaluate (Assignment Name: ${paramsdata.assignmentName})`}
                secondaryText={`Learner Name: ${joinByKeys(
                    paramsdata.learnerName,
                    ["firstname", "lastname"],
                    " "
                )} | (Asset Name: ${paramsdata.assetName})`}
            />
            {logData &&
                (<>
                    {assetType && assetType.value === 'BOOK' && (
                        <BookEvaluate
                            logData={logData}
                            scoreSelect={(valObj, ind) => {
                                setTeacherEval(valObj, ind);
                            }}
                        />
                    )}
                    {assetData && assetType && assetType.value === 'NB' && (
                        <Grid
                            container
                            sx={{
                                flexDirection: "row",
                                justifyContent: "flex-start",
                                height: '70vh',
                                overflow: "auto"
                            }}
                            className={styles.scrollBar}
                        >
                            <Grid
                                item xs={12}
                            >
                                {assetData &&
                                    assetData.content.content.info.asset_type_alias !== "ILT" && (
                                        <InstructionCard
                                            text={unicodeToString(
                                                assetData.content.content.epage.instruction.text
                                            )}
                                            // isJumpTo={false}
                                        />
                                    )}
                            </Grid>
                            <Grid item xs={12}>
                                <Box
                                    className={styles.scrollBar}
                                    sx={{
                                        border: 1,
                                        borderColor: "#EAECEE",
                                        borderRadius: 3,
                                        py:
                                            assetData &&
                                                ILTTypeAssets.indexOf(
                                                    assetData.content.content.info.asset_type_alias
                                                ) == -1
                                                ? "2"
                                                : "0",
                                        mx: 6,
                                        mt: 1,
                                        height:
                                            assetData &&
                                                assetData.content.content.info.asset_type_alias.toUpperCase() ==
                                                "ILT"
                                                ? "69vh"
                                                : "60vh",
                                        overflow: 'auto'
                                    }}
                                >
                                    <Grid
                                        container
                                        sx={{
                                            flexDirection: "row",
                                            flexFlow: "wrap",
                                            justifyContent: "center",
                                            px:
                                                assetData &&
                                                    ILTTypeAssets.indexOf(
                                                        assetData.content.content.info.asset_type_alias
                                                    ) == -1
                                                    ? 1
                                                    : 0,
                                            gap: 3,
                                            mt: 1
                                        }}
                                    >
                                        {assetData &&
                                            checkMediaAvailability() &&
                                            (ILTTypeAssets.indexOf(
                                                assetData.content.content.info.asset_type_alias
                                            ) == -1 ||
                                                FullWidthAssets.indexOf(
                                                    assetData.content.content.info.asset_type_alias
                                                ) != -1) && (
                                                <Grid item xs={4} sx={{ textAlign: "center", mt: 2 }}>
                                                    <MediaCard
                                                        article={
                                                            assetData.content.content.epage.instruction.media.article
                                                        }
                                                        image={
                                                            assetData.content.content.epage.instruction.media.image
                                                        }
                                                        audio={
                                                            assetData.content.content.epage.instruction.media.audio
                                                        }
                                                        video={
                                                            assetData.content.content.epage.instruction.media.video
                                                        }
                                                        questionText={
                                                            assetData.content.content.epage.options.question.text
                                                        }
                                                    />
                                                </Grid>
                                            )}
                                        <Grid
                                            item
                                            xs={
                                                assetData &&
                                                    ILTTypeAssets.indexOf(
                                                        assetData.content.content.info.asset_type_alias
                                                    ) != -1
                                                    ? 12
                                                    : assetData &&
                                                        FullWidthAssets.indexOf(
                                                            assetData.content.content.info.asset_type_alias
                                                        ) != -1
                                                        ? 12
                                                        : 7
                                            }
                                        >
                                            <NBEvaluate
                                                content={assetData.content.content}
                                                logData={logData}
                                                scoreSelect={(valObj, ind) => {
                                                    setTeacherEval(valObj, ind);
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Grid>
                        </Grid>
                    )}
                    <RewardsCard
                        save={(reaction, comment, trainerFeedbackAudio) => {
                            saveEvaluation(reaction, comment, trainerFeedbackAudio);
                        }} 
                    />
                </>
                )}
        </>
    );

}
const useStyles = makeStyles({
    scrollBar: {
        "&::-webkit-scrollbar": {
            width: "0.6em",
        },
        "&::-webkit-scrollbar-track": {
            backgroundColor: "#ffe600ff",
            "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
            borderRadius: 5,
        },
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#5f5600ff",
            borderRadius: 5,
        },
    },
});
export default AssessAssetTypes;